import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HouseService from "../../services/houseService";
import AuthService from "../../services/authService";

const HouseForm = ({ house, action }) => {
  const EDITMODE = action === "new" ? false : true;
  const [images, setImages] = useState([]);
  const auth = AuthService();
  const user = auth.getCurrentUser();
  const history = useNavigate();
  const houseService = HouseService();
  const [responseMessage, setResponseMessage] = useState("");

  const startingHouseData = {
    title: "",
    description: "",
    price: 0,
    houseStatus: "",
    status: "",
    rooms: 0,
    baths: 0,
    squaremts: 0,
    parking: 0,
    images: [],
  };

  if (EDITMODE) {
    startingHouseData["title"] = house.title;
    startingHouseData["description"] = house.houseDescription;
    startingHouseData["price"] = house.price;
    startingHouseData["houseStatus"] = house.houseStatus;
    startingHouseData["rooms"] = house.rooms;
    startingHouseData["baths"] = house.baths;
    startingHouseData["squaremts"] = house.squaremts;
    startingHouseData["parking"] = house.parking;
    startingHouseData["images"] = house.images;
  }
  const [houseData, setHouseData] = useState(startingHouseData);

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setHouseData((preState) => ({
      ...preState,
      [name]: value,
    }));
  };
  const handleImageChange = (event) => {
    const files = Array.from(event.target.files); // Convert FileList to Array
    setImages([...images, ...files]); // Append new images to the existing list
  };
  const removeImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
  };

  const addImageField = () => {
    setImages([...images, null]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append("title", houseData.title);
    form.append("description", houseData.description);
    form.append("price", houseData.price);
    form.append("houseStatus", houseData.houseStatus);
    form.append("rooms", houseData.rooms);
    form.append("baths", houseData.baths);
    form.append("squaremts", houseData.squaremts);
    form.append("parking", houseData.parking);
    form.append("owner_id", user);

    images.forEach((file, index) => {
      if (file) {
        form.append(`images[${index}]`, file);
      }
    });

    try {
      if (EDITMODE) {
        const res = await houseService.editHouse(form);
        setResponseMessage(res.message);
        setTimeout(() => {
          setResponseMessage("");
        }, 3000);
        setHouseData(startingHouseData);
        setImages([]);
      } else {
        const res = await houseService.addHouse(form);
        setResponseMessage(res.message);
        setTimeout(() => {
          setResponseMessage("");
        }, 3000);
        setHouseData(startingHouseData);
        setImages([]);
      }

      //history("/");
    } catch (error) {
      console.error("Error adding house:", error);
    }
  };

  return (
    <div className="house-form--dashboard">
      <h1>{EDITMODE ? "Editar Propiedad" : "Añadir Propiedad"}</h1>
      <div
        className={`response-message--houseForm ${
          responseMessage.includes("successfully") ? "success" : "error"
        }`}
      >
        {responseMessage && <p>{responseMessage}</p>}
      </div>
      <form
        onSubmit={handleSubmit}
        encType="multipart/form-data"
        className="dashboard__form"
      >
        <div>
          <label>Titulo</label>
          <input
            name="title"
            type="text"
            value={houseData.title}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Descripción</label>
          <textarea
            name="description"
            value={houseData.description}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Precio</label>
          <input
            name="price"
            type="number"
            value={houseData.price}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Tipo</label>
          <select
            name="houseStatus"
            id="houseStatus"
            value={houseData.houseStatus}
            onChange={handleChange}
            className="dashboard__form--select"
          >
            <option value="">Seleccione una opción</option>
            <option value="En Venta">En venta</option>
            <option value="Para Arrendar">Para Arrendar</option>
          </select>
        </div>
        <div>
          <label>Número de habitaciones</label>
          <input
            name="rooms"
            type="number"
            value={houseData.rooms}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Número de baños</label>
          <input
            name="baths"
            type="number"
            value={houseData.baths}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Metros cuadrados</label>
          <input
            name="squaremts"
            type="number"
            value={houseData.squaremts}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Número de Parqueaderos</label>
          <input
            name="parking"
            type="number"
            value={houseData.parking}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Images</label>
          <input type="file" multiple onChange={handleImageChange} required />
          <div>
            {images.map((image, index) => (
              <div key={index}>
                <p>{image.name}</p>
                <button onClick={() => removeImage(index)} type="button">
                  Remove
                </button>
              </div>
            ))}
          </div>
          {/*
          <label>Images</label>
          {images.map((image, index) => (
            <input
              key={index}
              type="file"
              onChange={(e) => handleImageChange(e, index)}
              placeholder="Select image"
              required
            />
          ))}
          <button
            type="button"
            onClick={addImageField}
            className="dashboard__form--img-btn"
          >
            Añadir imagen
          </button>*/}
        </div>
        <button type="submit" className="dashboard__form--btn">
          guardar
        </button>
      </form>
    </div>
  );
};

export default HouseForm;
